import React from 'react'

const IconXmlFile = ({ style, ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      style={{ flexShrink: 0, ...style }}
      {...props}
    >
      {/* Document */}
      <path
        d="M3 1.33398H9.33333L13 5.00065V14.6673H3V1.33398Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
      />

      {/* Folded corner */}
      <path
        d="M9.33301 1.33398V5.00065H12.9997"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
      />

      {/* XML brackets */}
      <path
        d="M6.33366 7.33398L4.66699 9.00065L6.33366 10.6673"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <path
        d="M9.66699 7.33398L11.3337 9.00065L9.66699 10.6673"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Slash */}
      <path
        d="M9.00033 7.00065L7.00033 11.0007"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default IconXmlFile
